/**
 * Copyright (c) [2015-2019] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import store from "../../state/store";
import { actionCreators } from "../../state/ducks/root";
import { Headphones, Lock, User } from "react-feather";
import "./index.css";
import { useForm } from "react-hook-form";
import { useToastContext } from "../../components/Toast";
import { apiLogin, apiTokenLogin } from "../../api/Login";
import janusApi from "../../janus-api";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [toUser, setToUser] = useState(null);
  const { register, handleSubmit } = useForm();
  const toast = useToastContext();

  // 解析 URL 参数
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tokenParam = searchParams.get('token');
    const toUserParam = searchParams.get('toUser');
    setToken(tokenParam);
    setToUser(toUserParam);
  }, [location.search]);

  // 自动 token 登录
  useEffect(() => {
    const performTokenLogin = async () => {
      setLoading(true);
      //console.log(token);
      if (token && token.trim() !== '') {
        setLoading(true);
        try {
          const res = await apiTokenLogin({ token });
          if (res.code === 0) {
            await store.dispatch(actionCreators.user.loginAfter());
            navigate("/?toUser=" + toUser);
          } else {
            toast.error("Token 授权失败，请使用账号密码登录", { duration: 1500 });
            setLoading(false);
          }
          // 模拟成功
          // 假设登录成功
          //toast.success("Token 登录成功！", { duration: 1500 });
          //await store.dispatch(actionCreators.user.loginAfter());
          //navigate("/");
        } catch (error) {
          toast.error("Token 登录失败，请使用账号密码登录", { duration: 1500 });
          setLoading(false);
        }
      }
    };
    performTokenLogin();
  }, [token]); // 依赖 token 变化

  // const room = useSelector((state) => state.room);
  // if (room.loggedIn) {
  //   return <Navigate to={`/room/${room.roomId}?user=${room.username}`} />;
  // }

  const onSubmit = async (data) => {
    const { username, password } = data;
    //console.log("登录表单数据:", { username, password });
    try {
      const res = await apiLogin({ username, password });
      if (res.code === 0) {
        toast.success("登录成功！", { duration: 1500 });
        await store.dispatch(actionCreators.user.loginAfter());
        navigate("/?toUser=" + toUser);
      } else {
        toast.error(res.msg, { duration: 1500 });
      }
    } catch (error) {
      toast.error("登录失败！", { duration: 1500 });
    }
  };

  useEffect(() => {
    janusApi.getRooms().then(setRooms);
  }, []);

  // 如果正在 token 登录，显示加载界面
  if (loading && token && token.trim() !== '') {
    return (
      <div
        className="page-login min-h-screen font-sans flex items-center justify-center"
        style={{
          background: "linear-gradient(135deg, #3498db 0%, #1a5f9e 100%)",
        }}
      >
        <div className="text-center text-white">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Headphones className="text-white" size={24} />
          </div>
          <h1 className="text-2xl font-bold mb-2">连接中...</h1>
        </div>
      </div>
    );
  }

  return (
    <div
      className="page-login min-h-screen font-sans"
      style={{
        background: "linear-gradient(135deg, #3498db 0%, #1a5f9e 100%)",
      }}
    >
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="login-container w-full max-w-md p-8">
          <div className="text-center mb-10">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-headset text-white text-2xl"></i>
              <Headphones className="text-white" size={24} />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">语音通信系统</h1>
            <p className="text-white/80">安全登录，畅享沟通</p>
          </div>

          <form
            id="loginForm"
            className="space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="text-blue-300" size={22} />
              </div>
              <input
                type="text"
                id="username"
                name="username"
                ref={register}
                className="input-field w-full pl-10 pr-4 py-3 rounded-xl bg-white/90 border-0 focus:ring-2 focus:ring-blue-400 focus:outline-none"
                placeholder="请输入账号"
                required
              />
            </div>

            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="text-blue-300" size={22} />
              </div>
              <input
                type="password"
                id="password"
                name="password"
                ref={register}
                className="input-field w-full pl-10 pr-10 py-3 rounded-xl bg-white/90 border-0 focus:ring-2 focus:ring-blue-400 focus:outline-none"
                placeholder="请输入密码"
                required
              />
            </div>
            <button
              type="submit"
              className="btn-primary w-full py-3 px-4 text-white font-medium rounded-xl shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400"
            >
              登录
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
